module.exports = __webpack_public_path__ + "static/history2-e3e2f0e10de74351c8d8831a56389562.pdf";